export default "__VITE_ASSET__C3OIYb5Q__"